import { CoreModel } from '../core/core.model';
export class AutocompleteModel extends CoreModel {
/**
 * Name of item property to be used as item label and selected value. Required.
 */
displayField: string;
/**
 * Array with items. Has lower priority then 'serverUrl'.
 */
source?: any[];
/**
 * Server url to be called for to take items. Has highter priority then 'source'.
 */
serverUrl?: string;
/**
 * Using chips for selected items. Default: false.
 */
useChips?: boolean;
/**
 * If useChips is true, then it is possible to set chips selection: single or multiple. Default: multiple.
 */
chipsSelected?: string;
/**
 * If chips can't be removed after selection. Default: false.
 */
chipsReadOnly?: boolean;
/**
 * Search items with using comma inside search input field. Default: false.
 */
multiselection?: boolean;
/**
 * If dropdown item can be selected multiple times. Default: true.
 */
uniqueSelected?: boolean;
/**
 * If dropdown must be opened on selecting items. Default: false.
 */
stayOpenedOnClick?: boolean;
/**
 * If to highlight search value in items labels. Default: false.
 */
highlighting?: boolean;
/**
 * To cache search results. Default: false.
 */
cache?: boolean;
/**
 * If to send request to a server on component init. Default: false.
 */
prefetch?: boolean;
/**
 * The amount of time from when the user stops typing to when the result is returned. Default: 250.
 */
delay?: boolean;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function AutocompleteModel_tsickle_Closure_declarations() {
/**
 * Name of item property to be used as item label and selected value. Required.
 * @type {?}
 */
AutocompleteModel.prototype.displayField;
/**
 * Array with items. Has lower priority then 'serverUrl'.
 * @type {?}
 */
AutocompleteModel.prototype.source;
/**
 * Server url to be called for to take items. Has highter priority then 'source'.
 * @type {?}
 */
AutocompleteModel.prototype.serverUrl;
/**
 * Using chips for selected items. Default: false.
 * @type {?}
 */
AutocompleteModel.prototype.useChips;
/**
 * If useChips is true, then it is possible to set chips selection: single or multiple. Default: multiple.
 * @type {?}
 */
AutocompleteModel.prototype.chipsSelected;
/**
 * If chips can't be removed after selection. Default: false.
 * @type {?}
 */
AutocompleteModel.prototype.chipsReadOnly;
/**
 * Search items with using comma inside search input field. Default: false.
 * @type {?}
 */
AutocompleteModel.prototype.multiselection;
/**
 * If dropdown item can be selected multiple times. Default: true.
 * @type {?}
 */
AutocompleteModel.prototype.uniqueSelected;
/**
 * If dropdown must be opened on selecting items. Default: false.
 * @type {?}
 */
AutocompleteModel.prototype.stayOpenedOnClick;
/**
 * If to highlight search value in items labels. Default: false.
 * @type {?}
 */
AutocompleteModel.prototype.highlighting;
/**
 * To cache search results. Default: false.
 * @type {?}
 */
AutocompleteModel.prototype.cache;
/**
 * If to send request to a server on component init. Default: false.
 * @type {?}
 */
AutocompleteModel.prototype.prefetch;
/**
 * The amount of time from when the user stops typing to when the result is returned. Default: 250.
 * @type {?}
 */
AutocompleteModel.prototype.delay;
}

